import { bool, object, func, string } from 'prop-types'

import { Typography, Link, Notification } from '@telus-uds/components-web'
import { utils } from '@digital-commerce/shared-utils'

import { getCartType } from '../../../../utils/cart'
import { getTopLevelInvalidCartItems } from '../util'

const { isBusinessCart } = utils.cart

const UNAUTHENTICATED_USER_CHANGE_URL =
  '/shop/home-services/bundle/build-your-own?linktype=invalid_cart_catalog'
const AUTHENTICATED_USER_CHANGE_URL = '/my-account?linktype=invalid_cart_catalog'
const SBS_NEW_CUSTOMER_URL = '/business/small?linktype=invalid_cart_catalog'
const M_AND_H_CART_TYPE = 'mixed'
const HS_CART_TYPE = 'hs'

const InvalidCartNotification = ({
  cart,
  lang,
  translate,
  isAuthenticated,
  removeItems,
  resetCart
}) => {
  const invalidCartItems = getTopLevelInvalidCartItems(cart)

  const cartType = getCartType(cart)

  const removeInvalidItemsClickHandler = async (e) => {
    e.preventDefault()
    await removeItems({
      items: Object.values(invalidCartItems)
    })
  }

  const getGoBackToCatalogUrl = () => {
    if (cartType === HS_CART_TYPE || cartType === M_AND_H_CART_TYPE) {
      if (isAuthenticated) {
        return AUTHENTICATED_USER_CHANGE_URL
      }
      if (isBusinessCart(cart)) {
        return SBS_NEW_CUSTOMER_URL
      }
      if (cartType === HS_CART_TYPE) {
        return UNAUTHENTICATED_USER_CHANGE_URL
      }
      return '/'
    }
    return '/'
  }

  const handleResetCartClick = async (event) => {
    event.preventDefault()
    await resetCart({
      language: lang
    })
  }

  const renderGoBackToCartMessage = cartType === HS_CART_TYPE || cartType === M_AND_H_CART_TYPE

  return (
    <Notification variant={{ validation: 'error' }} testID="cart-invalid-items-notification">
      {invalidCartItems.length > 0 ? (
        <Typography variant={{ size: 'medium' }}>
          {translate('appNotification.invalidItemsNotification.message')}
          {translate('appNotification.invalidItemsNotification.removeInvalidItems.message1')}
          <Link
            href="#"
            onClick={removeInvalidItemsClickHandler}
            testID="cart-invalid-items-remove-cta"
            variant={{ style: 'inline', size: 'small' }}
          >
            {translate('appNotification.invalidItemsNotification.removeInvalidItems.cta')}
          </Link>
          {translate('appNotification.invalidItemsNotification.removeInvalidItems.message2')}
          {renderGoBackToCartMessage ? (
            <>
              {translate('appNotification.invalidItemsNotification.conjunction')}
              <Link
                href={getGoBackToCatalogUrl()}
                testID="cart-invalid-items-goBackToCatalog-cta"
                variant={{ style: 'inline', size: 'small' }}
              >
                {translate('appNotification.invalidItemsNotification.goBackToCatalog.cta')}
              </Link>
              {translate('appNotification.invalidItemsNotification.goBackToCatalog.message')}
            </>
          ) : (
            translate('appNotification.invalidItemsNotification.period')
          )}
        </Typography>
      ) : (
        <Typography variant={{ size: 'medium' }}>
          {translate('appNotification.removeAllItemsNotification.message')}
          {translate('appNotification.removeAllItemsNotification.removeInvalidItems.message1')}
          <Link
            href="#"
            onClick={handleResetCartClick}
            testID="cart-remove-all-items-cta"
            variant={{ style: 'inline', size: 'small' }}
          >
            {translate('appNotification.removeAllItemsNotification.removeInvalidItems.cta')}
          </Link>
          {translate('appNotification.removeAllItemsNotification.removeInvalidItems.message2')}
        </Typography>
      )}
    </Notification>
  )
}

InvalidCartNotification.propTypes = {
  cart: object.isRequired,
  lang: string.isRequired,
  translate: func.isRequired,
  isAuthenticated: bool.isRequired,
  removeItems: func.isRequired,
  resetCart: func.isRequired
}

export default InvalidCartNotification
